(function () {
'use strict';

var C           = window.HavjoyCore;
var API_BASE    = 'https://api.havjoy.com';
var STORAGE_KEY = 'havjoy_sessions';

// ===== DOM =====
var elRoot        = document.getElementById('hj-myart-root');
var elLoading     = document.getElementById('hj-myart-loading');
var elEmpty       = document.getElementById('hj-myart-empty');
var elError       = document.getElementById('hj-myart-error');
var elMain        = document.getElementById('hj-myart-main');
var elImg         = document.getElementById('hj-myart-img');
var elTitle       = document.getElementById('hj-myart-title');
var elCounter     = document.getElementById('hj-myart-counter');
var elThumbs      = document.getElementById('hj-myart-thumbs');
var elVariants    = document.getElementById('hj-myart-variants');
var elPromoBanner = document.getElementById('hj-myart-promo-banner');
var elPromoText   = document.getElementById('hj-myart-promo-text');

if (!elRoot) return;

// ===== STATE =====
var allSessions  = [];
var sessionData  = null;
var productData  = null;
var activeIdx    = 0;
var selectedType = 'canvas';
var selectedSize = '9x12';

// ===== HELPERS =====
function readLocal() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
}

function formatMoney(cents) {
  return C ? C.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
}

function getParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

function deriveName(handle) {
  return (handle || '').split('-').map(function(w) {
    return w.charAt(0).toUpperCase() + w.slice(1);
  }).join(' ');
}

function showToast(msg, type) {
  if (C) { C.showToast(msg, type); return; }
  var el = document.createElement('div');
  el.style.cssText = 'background:#333;color:#fff;padding:1rem 1.4rem;border-radius:0.6rem;font-size:1.4rem;pointer-events:auto';
  el.textContent = msg;
  document.getElementById('toast-container').appendChild(el);
  setTimeout(function() { el.remove(); }, 3500);
}

// ===== PRODUCT FETCH =====
function fetchProductData(handle, callback) {
  if (!handle) { callback(null); return; }
  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(p) {
      callback({
        title: p.title,
        image: p.featured_image,
        variants: p.variants.map(function(v) {
          return { id: String(v.id), title: v.title, price: v.price, comparePrice: v.compare_at_price || v.price };
        })
      });
    })
    .catch(function(e) {
      console.warn('[HavjoyMerged] Product fetch failed:', e);
      callback(null);
    });
}

// ===== VARIANT LOOKUP =====
function findVariantByTitle(pattern) {
  if (!productData || !pattern) return null;
  var p = pattern.toLowerCase();
  for (var i = 0; i < productData.variants.length; i++) {
    if (productData.variants[i].title.toLowerCase().includes(p)) return productData.variants[i];
  }
  return null;
}

// ===== PRICES =====
function updateAddonPrices() {
  if (!productData || !elVariants || !C) return;

  var canvasVariant = findVariantByTitle(C.variantTitle(selectedType, selectedSize));
  var atcPriceEl = elVariants.querySelector('.canvas-atc-price-text');
  if (atcPriceEl && canvasVariant) atcPriceEl.textContent = formatMoney(canvasVariant.price);

  var digitalVariant = findVariantByTitle(C.VARIANT_DIGITAL);
  var digitalPriceEl = elVariants.querySelector('.digital-base-price');
  if (digitalPriceEl && digitalVariant) digitalPriceEl.textContent = formatMoney(digitalVariant.price);
}

// ===== CART =====
function cartProperties() {
  return { '_your_design': sessionData.result_url, '_session_id': sessionData.session_id };
}

async function addToCart(variantId, btn) {
  var origText = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
  try {
    var r = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: cartProperties() }] })
    });
    if (!r.ok) { var e = await r.json().catch(function(){return{};}); throw new Error(e.description || 'HTTP ' + r.status); }
    if (typeof CartDrawerController !== 'undefined') {
      CartDrawerController.open();
      CartDrawerController.update().catch(console.error);
    } else { window.location.href = '/cart'; }
    if (btn) {
      btn.textContent = 'Added ✓';
      setTimeout(function() { btn.disabled = false; btn.textContent = origText; }, 2000);
    }
  } catch(err) {
    showToast('Failed to add to cart. Please try again.', 'error');
    console.error(err);
    if (btn) { btn.disabled = false; btn.textContent = origText; }
  }
}

// ===== VARIANT CARDS =====
function showVariantSkeleton() {
  if (!elVariants) return;
  elVariants.innerHTML = '<div style="padding:2rem;text-align:center;opacity:0.4;font-size:1.4rem">Loading options...</div>';
}

function injectAndWireVariants() {
  if (!elVariants || !C || !productData) return;
  C.injectVariantCards(elVariants, productData);
  C.syncButtonUI(elVariants, '.print-type-btn', 'type', selectedType);
  C.syncButtonUI(elVariants, '.size-btn', 'value', selectedSize);
  updateAddonPrices();
}

// ===== EVENT DELEGATION (wired once on init) =====
function wireVariantEvents() {
  if (!elVariants || !C) return;

  elVariants.addEventListener('click', function(e) {

    // Print type toggle
    var ptBtn = e.target.closest('.print-type-btn');
    if (ptBtn) {
      selectedType = ptBtn.dataset.type;
      var ptInput = elVariants.querySelector('.print-type-input');
      if (ptInput) ptInput.value = selectedType;
      C.syncButtonUI(elVariants, '.print-type-btn', 'type', selectedType);
      updateAddonPrices();
      return;
    }

    // Size toggle
    var szBtn = e.target.closest('.size-btn');
    if (szBtn) {
      selectedSize = szBtn.dataset.value;
      var szInput = elVariants.querySelector('.addon-size[data-addon="canvas"]');
      if (szInput) szInput.value = selectedSize;
      C.syncButtonUI(elVariants, '.size-btn', 'value', selectedSize);
      updateAddonPrices();
      return;
    }

    // Canvas ATC
    var atcBtn = e.target.closest('.canvas-atc-btn');
    if (atcBtn) {
      var szInput2 = elVariants.querySelector('.addon-size[data-addon="canvas"]');
      var ptInput2 = elVariants.querySelector('.print-type-input');
      if (szInput2) selectedSize = szInput2.value;
      if (ptInput2) selectedType = ptInput2.value;
      var v = findVariantByTitle(C.variantTitle(selectedType, selectedSize));
      if (!v) { showToast('Variant not available', 'warning'); return; }
      addToCart(v.id, atcBtn);
      return;
    }

    // Download Now
    var dlBtn = e.target.closest('.download-now-btn');
    if (dlBtn) {
      var dv = findVariantByTitle(C.VARIANT_DIGITAL);
      if (!dv) { showToast('Digital variant not found', 'error'); return; }
      addToCart(dv.id, dlBtn);
      return;
    }
  });
}

// ===== MAIN IMAGE SWAP =====
function swapMainImage(url) {
  if (!elImg) return;
  elImg.style.transition = 'opacity 0.2s';
  elImg.style.opacity = '0';
  setTimeout(function() {
    elImg.src = url;
    elImg.onload = function() { elImg.style.opacity = '1'; };
  }, 200);
}

// ===== COUNTER =====
function updateCounter() {
  if (!elCounter) return;
  if (allSessions.length <= 1) { elCounter.style.display = 'none'; return; }
  elCounter.style.display = '';
  elCounter.textContent = (activeIdx + 1) + ' / ' + allSessions.length + ' SELECTED';
}

// ===== THUMBNAIL STRIP =====
function deriveCategory(handle) {
  return (handle || '').split('-')[0].toUpperCase();
}

function renderThumbs() {
  if (!elThumbs) return;
  if (allSessions.length <= 1) { elThumbs.style.display = 'none'; return; }
  elThumbs.style.display = '';
  elThumbs.innerHTML = '';
  allSessions.forEach(function(sess, i) {
    var btn = document.createElement('button');
    btn.className = 'hj-myart__thumb' + (i === activeIdx ? ' hj-myart__thumb--active' : '');
    var cat = deriveCategory(sess.product_handle).slice(0, 4);
    btn.innerHTML =
      '<img src="' + sess.result_url + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
      '<span class="hj-myart__thumb-label">' + cat + '</span>';
    btn.addEventListener('click', function() { onThumbClick(i); });
    elThumbs.appendChild(btn);
  });
}

// ===== THUMBNAIL CLICK =====
function onThumbClick(idx) {
  if (idx === activeIdx) return;
  activeIdx = idx;
  var sess = allSessions[idx];

  var url = new URL(window.location.href);
  url.searchParams.set('sid', sess.session_id);
  history.pushState({ sid: sess.session_id }, '', url.toString());

  elThumbs.querySelectorAll('.hj-myart__thumb').forEach(function(t, i) {
    t.classList.toggle('hj-myart__thumb--active', i === idx);
  });

  updateCounter();
  swapMainImage(sess.result_url);
  if (elTitle) elTitle.textContent = deriveName(sess.product_handle);

  selectedType = 'canvas';
  selectedSize = '9x12';
  productData  = null;
  sessionData  = sess;

  showVariantSkeleton();
  fetchProductData(sess.product_handle, function(data) {
    if (allSessions[activeIdx] !== sess) return;
    productData = data;
    injectAndWireVariants();
  });
}

window.addEventListener('popstate', function(e) {
  var sid = e.state && e.state.sid;
  if (!sid) return;
  for (var i = 0; i < allSessions.length; i++) {
    if (allSessions[i].session_id === sid) { onThumbClick(i); break; }
  }
});

// ===== PROMO BANNER =====
function checkPromoBanner() {
  var promo = getParam('promo');
  if (!promo || !elPromoBanner) return;
  elPromoBanner.style.display = 'block';
  if (elPromoText) elPromoText.textContent = promo.toUpperCase() + ' · $10 OFF AT CHECKOUT';
}

// ===== BATCH SESSION FETCH =====
function fetchAllSessions(ids) {
  return fetch(API_BASE + '/session_info?sessionId=' + ids.join(','))
    .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function(data) { return data.sessions || [data]; });
}

// ===== INIT =====
function init() {
  checkPromoBanner();
  wireVariantEvents();

  var local    = readLocal();
  var sidParam = getParam('sid');

  var ids = local.map(function(l) { return l.sessionId; }).filter(Boolean);
  if (sidParam && ids.indexOf(sidParam) === -1) ids.unshift(sidParam);

  if (!ids.length) {
    elLoading.style.display = 'none';
    elEmpty.style.display   = 'block';
    return;
  }

  fetchAllSessions(ids)
    .then(function(sessions) {
      var order = {};
      ids.forEach(function(id, i) { order[id] = i; });
      sessions.sort(function(a, b) { return (order[a.session_id] || 0) - (order[b.session_id] || 0); });

      allSessions = sessions.filter(function(s) { return s.status === 'completed' && s.result_url; });

      if (!allSessions.length) {
        elLoading.style.display = 'none';
        (sidParam ? elError : elEmpty).style.display = 'block';
        return;
      }

      var targetIdx = 0;
      if (sidParam) {
        for (var i = 0; i < allSessions.length; i++) {
          if (allSessions[i].session_id === sidParam) { targetIdx = i; break; }
        }
      }
      activeIdx = targetIdx;

      var active = allSessions[activeIdx];
      history.replaceState({ sid: active.session_id }, '', window.location.href);

      elLoading.style.display = 'none';
      elMain.style.display    = 'block';

      renderThumbs();
      updateCounter();

      elImg.src = active.result_url;
      if (elTitle) elTitle.textContent = deriveName(active.product_handle);
      sessionData = active;

      showVariantSkeleton();
      fetchProductData(active.product_handle, function(data) {
        productData = data;
        injectAndWireVariants();
      });
    })
    .catch(function(e) {
      console.error('[HavjoyMerged] Failed to load sessions:', e);
      elLoading.style.display = 'none';
      (sidParam ? elError : elEmpty).style.display = 'block';
    });
}

init();

})();
